var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clarity:notification-solid",
    clipPath: "url(#clip0_6113_1522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.3406 18.9269L21.3424 18.9285L21.3999 18.9792V20.1336H2.5332V18.9792L2.59068 18.9285L2.59071 18.9286L2.59587 18.9239C3.26233 18.3191 3.84497 17.6279 4.32831 16.8688L4.34097 16.8489L4.3517 16.8279C4.89254 15.7703 5.21669 14.6154 5.30515 13.4308L5.30654 13.4122V13.3936L5.30654 10.1003L5.30654 10.0993C5.30327 8.47727 5.88792 6.90906 6.9522 5.68508C8.01648 4.4611 9.48828 3.66428 11.095 3.44222L11.5265 3.38258V2.94693V2.07359C11.5265 1.97016 11.5676 1.87096 11.6408 1.79782C11.7139 1.72468 11.8131 1.68359 11.9165 1.68359C12.02 1.68359 12.1192 1.72468 12.1923 1.79782C12.2654 1.87096 12.3065 1.97016 12.3065 2.07359V2.93359V3.37378L12.7432 3.42956C14.3644 3.63669 15.8542 4.42872 16.9327 5.65683C18.0111 6.88494 18.604 8.4646 18.5999 10.099V10.1003V13.3936V13.4122L18.6013 13.4308C18.6897 14.6154 19.0139 15.7703 19.5547 16.8279L19.5662 16.8504L19.5799 16.8716C20.0718 17.6328 20.664 18.3241 21.3406 18.9269Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.2129 21.332C10.2714 21.7546 10.4808 22.1418 10.8024 22.422C11.1241 22.7022 11.5363 22.8566 11.9629 22.8566C12.3895 22.8566 12.8017 22.7022 13.1234 22.422C13.445 22.1418 13.6544 21.7546 13.7129 21.332H10.2129Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6113_1522"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileNotification);
export default __webpack_public_path__ + "static/media/profile-notification.6371ca6dfad83255a29af6612ce66c77.svg";
export { ForwardRef as ReactComponent };